import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["error", "className", "title", "captionTop", "caption", "required"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { forwardRef, useState, useCallback, useMemo } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";

var IconPassword = function IconPassword(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("style", {
      type: "text/css",
      children: [".icon_password_svg", "{", "fill:#666666;", "}"]
    }), /*#__PURE__*/_jsx("path", {
      className: "icon_password_svg",
      d: "M12.3,7.3V5.5c0,0,0-0.1,0-0.1C12.3,2.4,9.9,0.1,7,0h0C4.1,0.1,1.7,2.4,1.7,5.3c0,0.1,0,0.1,0,0.2v1.9 C0.8,7.4,0,8.1,0,9v7.3c0,1,0.8,1.7,1.8,1.7h10.5c1,0,1.7-0.7,1.8-1.7V9C14,8.1,13.2,7.4,12.3,7.3L12.3,7.3L12.3,7.3z M3,5.2 c0,0,0-0.1,0-0.1c0-2.2,1.8-4,4-4h0c2.2,0,4,1.8,4,4c0,0,0,0.1,0,0.1v2.2H3V5.2z M12.8,16.2c0,0.4-0.3,0.7-0.7,0.7H1.9 c-0.4,0-0.7-0.3-0.7-0.7v-7c0-0.4,0.3-0.7,0.7-0.7h10.1c0.4,0,0.7,0.3,0.7,0.7l0,0L12.8,16.2z"
    }), /*#__PURE__*/_jsx("path", {
      className: "icon_password_svg",
      d: "M8.7,11.8L8.7,11.8c0-1-0.8-1.7-1.7-1.7s-1.7,0.8-1.7,1.7c0,0.7,0.5,1.4,1.2,1.6h0v1.3c0,0.3,0.3,0.6,0.6,0.6 l0,0c0.3,0,0.6-0.2,0.6-0.6v-1.3C8.3,13.2,8.7,12.6,8.7,11.8L8.7,11.8L8.7,11.8L8.7,11.8z M7,12.4c-0.3,0-0.6-0.3-0.6-0.6 c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6l0,0C7.6,12.2,7.3,12.5,7,12.4L7,12.4z"
    })]
  }));
};

IconPassword.defaultProps = {
  viewBox: "0 0 14 18"
};
import ErrorMessage from "./ErrorMessage";
import { usePreventContextMenu } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PasswordField = /*#__PURE__*/forwardRef(function (props, ref) {
  var error = props.error,
      className = props.className,
      title = props.title,
      captionTop = props.captionTop,
      caption = props.caption,
      required = props.required,
      _props = _objectWithoutProperties(props, _excluded);

  var _usePreventContextMen = usePreventContextMenu(),
      _usePreventContextMen2 = _slicedToArray(_usePreventContextMen, 2),
      on = _usePreventContextMen2[0],
      off = _usePreventContextMen2[1];

  var _useState = useState(false),
      toggleState = _useState[0],
      setToggleState = _useState[1];

  var handleClick = useCallback(function () {
    setToggleState(!toggleState);
  }, [toggleState]);
  var inputType = useMemo(function () {
    if (toggleState) return "text";
    if (!toggleState) return "password";
  }, [toggleState]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, _defineProperty({}, styles.required, required)),
      children: title
    }), captionTop && /*#__PURE__*/_jsx("p", {
      className: styles.textInputCaption,
      children: captionTop
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.hiddenPass,
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        type: inputType,
        name: "password",
        className: classnames(styles.textInput, styles.passwordInput, className, _defineProperty({}, styles.error, error)),
        defaultValue: "",
        required: required,
        onFocus: off,
        onBlur: on
      }, _props)), /*#__PURE__*/_jsx("span", {
        className: styles.iconPassword,
        children: /*#__PURE__*/_jsx(IconPassword, {})
      }), /*#__PURE__*/_jsx("span", {
        className: classnames(styles.passwordTogle, _defineProperty({}, styles.eyeOff, toggleState)),
        onClick: handleClick
      })]
    }), caption && /*#__PURE__*/_jsxs("p", {
      className: styles.caption,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.iconCaution,
        children: /*#__PURE__*/_jsx(IconCaution, {})
      }), caption]
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
});
PasswordField.displayName = "PasswordField";
export default PasswordField;